import React from 'react'
import { AccountContainer } from '../../AccountContainer'
import { useContext } from './Context'
import { Order } from '../../../../components/Order'
import { GoToCartButton } from '../../../../components/Order/GoToCartButton'
import { PayBalanceButton } from '../../../../components/PayBalanceButton'
import { PageTitle } from '../../../../components/PageTitle'

export const Layout = () => {
  const { orderId } = useContext()

  const components = {
    CheckoutButton: () => (
      <>
        <GoToCartButton />
        <PayBalanceButton />
      </>
    ),
  }

  return (
    <AccountContainer>
      <PageTitle
        title={`Order #${orderId}`}
        description={`View details and status of your order #${orderId}. Track your shipment and manage your purchase.`}
      />
      <Order filter={{ _id: orderId }} showChat={true} components={components} />
    </AccountContainer>
  )
}
